export default {
  BEFORE: 'BEFORE',
  AFTER: 'AFTER',
  AFTER_ISSUE_DATE: 'AFTER_ISSUE_DATE',
  BEFORE_EVENT_DATE: 'BEFORE_EVENT_DATE',
  AFTER_EVENT_DATE: 'AFTER_EVENT_DATE'
}